import App from 'app/app.js';
import 'app/action/SessionTimeoutAction.js';
import 'app/service/BlockService.js';
import 'app/store/MessageStore.js';

function SelectionTemplateDataStore($http, $q, SessionTimeoutAction, MessageStore, BlockService) {
  this.selectionTemplateDataCollection = [];
  var contentFailureKey = 'CONTENT_ERROR_FAILURE';

  this.clearAll = function () {
    //faster than using splice() method or setting length to zero
    while (this.selectionTemplateDataCollection.length) {
      this.selectionTemplateDataCollection.pop();
    }
  };

  this.handleErrors = function (data) {
    this.clearAll();
    if (!!data && !!data.errors) {
      data.errors.forEach(function (error) {
        MessageStore.createSystem(error.key || contentFailureKey, error.params);
      });
    } else {
      MessageStore.createSystem(contentFailureKey);
    }
  };

  this.getSelectionTemplateDataMap = function (name) {
    var dfd = $q.defer();

    var cache = this.getCachedSelectionTemplateDataMap(name);
    if (!!cache) {
      dfd.resolve(cache);
      return dfd.promise;
    }

    BlockService.blockUI();
    $http({ method: 'GET', url: 'selectionTemplateData/loadSelectionTemplate?name=' + name })
      .then(
        function (response) {
          if (response.data.success) {
            var templateMap = response.data.data.selectionTemplateDataMap;
            this.selectionTemplateDataCollection.push(templateMap);
            dfd.resolve(templateMap);
          } else {
            this.handleErrors(response.data);
            dfd.reject('CONTENT_ERROR_FAILURE');
          }
        }.bind(this)
      )
      .catch(
        function (response) {
          this.handleErrors(response.data);
          dfd.reject();
        }.bind(this)
      )
      ['finally'](function () {
        BlockService.unblockUI();
      });

    return dfd.promise;
  };

  this.getCachedSelectionTemplateDataMap = function (name) {
    return R.find(R.propEq('templateName', name))(this.selectionTemplateDataCollection);
  };

  this.onSessionTimeout = function (type, args) {
    this.clearAll();
  };

  SessionTimeoutAction.register(this.onSessionTimeout.bind(this));
}

App.service('SelectionTemplateDataStore', [
  '$http',
  '$q',
  'SessionTimeoutAction',
  'MessageStore',
  'BlockService',
  SelectionTemplateDataStore
]);
